import AccessLevel from '@/lib/constants/AccessLevel.enum';
import { createContext } from 'react';

const AccessLevelContext = createContext<AccessLevel>(AccessLevel.MEMBER);

export default AccessLevelContext;
